var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7129_33094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 13.6508C8.71028 14.2841 9.6448 14.6693 10.6693 14.6693C12.8784 14.6693 14.6693 12.8784 14.6693 10.6693C14.6693 8.82465 13.4206 7.27166 11.7225 6.80939M4.28272 6.80938C2.58456 7.27165 1.33594 8.82465 1.33594 10.6693C1.33594 12.8784 3.1268 14.6693 5.33594 14.6693C7.54508 14.6693 9.33594 12.8784 9.33594 10.6693C9.33594 10.1489 9.23659 9.65182 9.05582 9.19583M12.0026 5.33594C12.0026 7.54508 10.2117 9.33594 8.0026 9.33594C5.79347 9.33594 4.0026 7.54508 4.0026 5.33594C4.0026 3.1268 5.79347 1.33594 8.0026 1.33594C10.2117 1.33594 12.0026 3.1268 12.0026 5.33594Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7129_33094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.467c587b5805e6695b21d40a2d5a56f6.svg";
export { ForwardRef as ReactComponent };